import { render, staticRenderFns } from "./NegociarDivida.vue?vue&type=template&id=5ae66445&scoped=true"
import script from "./NegociarDivida.vue?vue&type=script&lang=js"
export * from "./NegociarDivida.vue?vue&type=script&lang=js"
import style0 from "./NegociarDivida.vue?vue&type=style&index=0&id=5ae66445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae66445",
  null
  
)

export default component.exports